export class Choice {

    label: string;
    value: string;
    default: boolean;
    hint: string;
    reportText: string;
}
